<template>
	<div>
		<v-dialog v-model="dialog_payment_terms" no-click-animation scrollable persistent content-class="full-height" transition="dialog-bottom-transition">
			<v-card>
	        	<v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader>Select Term of Payment</v-subheader>
	        	</v-card-title>
	        	<v-divider></v-divider>
		        <v-card-text full-height nopadding>

			        <v-list nopadding>
			        	<v-list-tile v-for="(item, index) in paymentTerms" :key="index" @click="updatePaymentTerm(item)">

				            <v-list-tile-content>
				              <v-list-tile-title>{{!item ? 'Custom' : item != -1 ? item + ' Days' : 'No Due Date'}}</v-list-tile-title>
				            </v-list-tile-content>

				            <v-list-tile-action>
						        <v-icon v-if="item == selectedPaymentTerm">radio_button_checked</v-icon>
						        <v-icon v-else>radio_button_unchecked</v-icon>
				            </v-list-tile-action>

			        	</v-list-tile>
			        </v-list>
		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
		        </v-card-actions>
		    </v-card>

	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['updatePaymentTerm', 'selectedPaymentTerm'],
		data(){
			return{
				paymentTerms: [7, 15, 21, 30, 45, 90, -1, null],
				dialog_payment_terms:false,
			}
		},
		methods:{
			openDialogWeb: function () {
				this.dialog_payment_terms = true;
			},
			closeDialogWeb: function () {
				this.dialog_payment_terms = false;
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/dialogs/dialog_payment_terms.vue